// Shared MUI button styling for cash-offer CTAs.
// Use alongside color="warning" and variant="contained".
export const primaryCtaSx = {
  fontFamily: "latoBold, Lato, sans-serif",
  fontSize: "1rem",
  fontWeight: 700,
  lineHeight: 1.3,
  minHeight: 48,
  px: 3,
  py: 1.25,
  textTransform: "uppercase",
  textAlign: "center",
};

export const navCtaSx = {
  ...primaryCtaSx,
  fontSize: "0.875rem",
  minHeight: 40,
  px: 2,
  py: 0.75,
  whiteSpace: "nowrap",
};